module.exports = __webpack_public_path__ + "assets/img/29_226_big.8a17cbea.jpg";